export function isTaskComponentLinked(componentRef, linkedFields = {}) {
    return Boolean(componentRef) && Object.values(linkedFields ?? {}).some(Boolean)
}
